<div *ngIf="gr.placeInService">
  <section *ngIf="gr.placeInService.customerAuthorization">
    <h3>Vollmacht:</h3>
    <p>Vollmacht des Kunden liegt vor</p>
  </section>

  <section
    *ngIf="
      ((showExternalIdField$ | async) && gr.externalId) ||
      ((showExternalCustomerIdField$ | async) && gr.externalCustomerId)
    ">
    <h3>Externe Daten</h3>
    <app-value-with-label
      *ngIf="(showExternalIdField$ | async) && gr.externalId"
      [label]="'Externe ID'"
      [value]="gr.externalId" />
    <app-value-with-label
      *ngIf="(showExternalCustomerIdField$ | async) && gr.externalCustomerId"
      [breakLineBefore]="true"
      [label]="'Externe Kunden-ID'"
      [value]="gr.externalCustomerId" />
  </section>

  <!-- TODO: refine v1 legacy layout for storage-only place-in if still needed -->
  <section *ngIf="gr.formVersion === 'v1' && (totalActivePower > 0 || totalApparentPower > 0)">
    <h3>Installierte Leistung (Speicher):</h3>
    <table>
      <thead>
        <th></th>
        <th><b>Gemeldete Leistung</b></th>
        <th><b>Tatsächlich installierte Leistung</b></th>
      </thead>
      <tbody>
        <tr *ngIf="totalActivePower > 0">
          <td><b>Wirkleistung</b></td>
          <td>{{ totalActivePower | number : undefined : 'de-DE' }} kW</td>
          <td>{{ gr.placeInService.effectiveActivePowerMax | number : undefined : 'de-DE' }} kW</td>
        </tr>
        <tr *ngIf="totalApparentPower > 0">
          <td><b>Scheinleistung</b></td>
          <td>{{ totalApparentPower | number : undefined : 'de-DE' }} kW</td>
          <td>{{ gr.placeInService.effectiveApparentPowerMax | number : undefined : 'de-DE' }} kW</td>
        </tr>
      </tbody>
    </table>
  </section>

  <section *ngIf="gr.formVersion === 'v2'">
    <h3>Speicher</h3>
    <section *ngIf="gr.storages?.length > 0">
      <app-storages-summary [storages]="gr.storages"></app-storages-summary>
      <div>
        <app-value-with-label
          *ngIf="gr.consumers[0]?.power as power"
          [label]="'Leistung (kW, pro Speicher)'"
          [value]="power.toString()"></app-value-with-label>
      </div>
    </section>
    <section *ngIf="gr.producers?.length">
      <h4>Wechselrichter / Entladeleistung</h4>
      <app-producers-summary [producers]="gr.producers"></app-producers-summary>
    </section>
  </section>

  <app-tenant-config-proxy
    [configPath]="'gridRegistration.mastrValidationConfig.enableMastrValidationForPlaceInServiceRequest'">
    <ng-template #proxyContent>
      <section *ngIf="gr.maStRNumberStorage" style="margin-bottom: 2rem">
        <h3>Vergleichstabelle Marktstammdatenregister (Speicher)</h3>
        <app-mastr-validation
          [grData]="gr"
          [companyLocationExternalId]="gr?.companyLocation?.external_id"
          [mastrNumber]="gr.maStRNumberStorage"
          mastrFetchMode="storageUnit" />
      </section>
    </ng-template>
  </app-tenant-config-proxy>

  <section *ngIf="hasMeterValues">
    <h3>Zählerstände</h3>
    <p>
      <app-value-with-label [label]="'Zählernummer'" [value]="gr.meterNumber" />
    </p>
    <p>
      <app-value-with-label
        [label]="'Zählerstand von Zählerwerk 1' + (gr.meterOne.obisCode ? ' - ' + gr.meterOne.obisCode : '')"
        [value]="gr.meterOne.value" />
    </p>
    <p *ngIf="gr.meterTwo?.value">
      <app-value-with-label
        [label]="'Zählerstand von Zählerwerk 2' + (gr.meterTwo.obisCode ? ' - ' + gr.meterTwo.obisCode : '')"
        [value]="gr.meterTwo.value" />
    </p>
  </section>

  <section *ngIf="gr.feederConnectionStandard == 'VDE4105' || !gr.feederConnectionStandard">
    <section>
      <h3>VDE 4105 Checkliste</h3>
      <p>
        <app-value-with-label
          *ngIf="gr.placeInService.effectiveAndRequestedValuesMatch != null"
          [label]="'Übereinstimmung der Daten aus dem Antrag zur Netzanmeldung mit dem Anlagenaufbau?'"
          [value]="gr.placeInService.effectiveAndRequestedValuesMatch | jaNeinPipe"></app-value-with-label>
      </p>
      <p>
        <app-value-with-label
          *ngIf="gr.placeInService.invoiceMeteringCheckDone != null"
          [label]="'Abrechnungsmessung: Vorinbetriebsetzungsprüfung + Inbteriebsetzungsprüfung erfolgt?'"
          [value]="gr.placeInService.invoiceMeteringCheckDone | jaNeinPipe"></app-value-with-label>
      </p>
      <p>
        <app-value-with-label
          *ngIf="gr.placeInService.vdeCertificateExists != null"
          [label]="
            'Einheitenzertifikat für Erzeugungseinheiten und/oder Speicher (soweit jeweils in der Kundenanlage verbaut) ' +
            'vorhanden (siehe Vordruck E. 4) bzw. nach VDE-AR-N 4110?'
          "
          [value]="gr.placeInService.vdeCertificateExists | jaNeinPipe"></app-value-with-label>
      </p>
      <p>
        <app-value-with-label
          *ngIf="gr.placeInService.powerDirectionSensorCheckDone != null"
          [label]="'Energieflussrichtungsensor - Funktionstest durch Errichter durchgeführt und bestanden?'"
          [value]="gr.placeInService.powerDirectionSensorCheckDone | jaNeinPipe"></app-value-with-label>
      </p>
      <p>
        <app-value-with-label
          *ngIf="gr.placeInService.vdeArN4100_55_CertificateExists != null"
          [label]="
            'Soweit in jeweiligen Anschlussfall erforderlich: Zertifikat für die Leistungsflussüberwachung am Netzanschlusspunkt (P<sub>AV, E</sub> - Überwachung, Symmetrieeinrichtung nach VDE-AR-N 4100, 5.5)?'
          "
          [value]="gr.placeInService.vdeArN4100_55_CertificateExists | jaNeinPipe"></app-value-with-label>
      </p>
      <p>
        <app-value-with-label
          *ngIf="gr.placeInService.powerProtectionCertificateExists != null"
          [label]="'Zertifikat für den NA-Schutz vorhanden (siehe Vordruck E.6)?'"
          [value]="gr.placeInService.powerProtectionCertificateExists | jaNeinPipe"></app-value-with-label>
      </p>
      <p>
        <app-value-with-label
          *ngIf="gr.placeInService.factorCosphiCheck != null"
          [label]="
            'Verfahren zur Blindleistungsbereitstellung: ' +
            (gr.reactivePowerProvisioningMethod
              | appDisplayName : (this.metaService.reactivePowerProvisioningMethods$ | async)) +
            ' eingestellt?'
          "
          [value]="gr.placeInService.factorCosphiCheck | jaNeinPipe"></app-value-with-label>
        <!-- ' + {{ 'cosPhiValue' | uiAdaptionValue }} + ' -->
      </p>
    </section>

    <section>
      <h3>NA-Schutz</h3>
      <p>
        <app-value-with-label
          *ngIf="gr.placeInService.naProtection != null"
          [label]="'Art des NA-Schutzes:'"
          [value]="
            gr.placeInService.naProtection == naProtectionTypeEnum.Integrated ? 'Integriert' : 'Zentral'
          "></app-value-with-label>
      </p>
      <p>
        <app-value-with-label
          *ngIf="gr.placeInService.overvoltageProtectionType != null"
          [label]="'Eingestellter Wert des Spannungssteigerungsschutz: '"
          [value]="gr.placeInService.overvoltageProtectionType + ' V'"></app-value-with-label>
      </p>
      <p>
        <app-value-with-label
          *ngIf="gr.placeInService.overvoltageReleaseTestDone != null"
          [label]="'Auslösetest &quot;Zentraler NA-Schutz - Kuppelschalter&quot; erfolgreich durchgeführt?'"
          [value]="gr.placeInService.overvoltageReleaseTestDone | jaNeinPipe"></app-value-with-label>
      </p>
      <p>
        <app-value-with-label
          *ngIf="gr.placeInService.triggerCircuitTestDone != null"
          [label]="
            'Auslösekreises &quot;Zentraler NA-Schutz - Kuppelschalter&quot; nach Ruhestromprinzip ausgeführt und geprüft?'
          "
          [value]="gr.placeInService.triggerCircuitTestDone | jaNeinPipe"></app-value-with-label>
      </p>
    </section>

    <section>
      <h3>
        P
        <sub>AV, E</sub>
        - Überwachung
      </h3>
      <p>
        <app-value-with-label
          *ngIf="gr.placeInService.pMonitoringExists != null"
          [label]="'P<sub>AV, E</sub> - Überwachung vorhanden'"
          [value]="gr.placeInService.pMonitoringExists | jaNeinPipe"></app-value-with-label>
      </p>
      <p>
        <app-value-with-label
          *ngIf="gr.placeInService.effectivePave != null"
          [label]="'Eingestellte Wirkleistung P<sub>AV,E</sub>: '"
          [value]="gr.placeInService.effectivePave.toString() + ' kW'"></app-value-with-label>
      </p>
      <p>
        <app-value-with-label
          *ngIf="gr.placeInService.paveTestDone != null"
          [label]="'Funktionstest P<sub>AV,E</sub> - Überwachung erfolgreich durchgeführt?'"
          [value]="gr.placeInService.paveTestDone | jaNeinPipe"></app-value-with-label>
      </p>
    </section>

    <section>
      <h3>Technische Einrichtung zur Reduzierung der Einspeiseleistung:</h3>
      <form-row>
        <app-feedin-management-summary
          [companyLocation]="gr.companyLocation"
          [feedInManagementInfo]="gr.feedInManagementInfo"
          [totalPower]="gr.newInstalledPower || gr.newProduction"
          [producers]="gr.producers"
          [pvModules]="gr.pvModules"></app-feedin-management-summary>
      </form-row>
    </section>
    <section>
      <p>
        <!-- ToDo @Marius: NAME STADTWERK mit Tenant ersetzen -->
        <app-value-with-label
          *ngIf="gr.placeInService.eegConfirmation != null"
          [label]="
            'Ich / Wir bestätigen, dass die Vorgaben gemäß §9 Erneuerbare-Energien-Gesetz (EEG) unter Berücksichtigung der &quot;Technische Vorgaben&quot; für das Einspeisermanagement bei EEG-Anlagen entsprechend umgesetzt wurde.'
          "
          [value]="gr.placeInService.eegConfirmation | jaNeinPipe"></app-value-with-label>
      </p>
      <p>
        <app-value-with-label
          *ngIf="gr.placeInService.flawlessFunctionGuarantee != null"
          [label]="
            'Die einwandfreie Funktion der Steuereinrichtung wird gewährleistet? ' +
            'Der Anlagenbetreiber verpflichtet sich, die Einrichtung stets in technisch einwandfreiem Zustand zu halten?'
          "
          [value]="gr.placeInService.flawlessFunctionGuarantee | jaNeinPipe"></app-value-with-label>
      </p>
    </section>

    <section>
      <h3>Symetriebedingung</h3>
      <p>
        <app-value-with-label
          *ngIf="gr.placeInService.symmetryConditions != null"
          [breakLine]="true"
          [label]="'Die Symmetriebedingung wird eingehalten...'"
          [value]="
            gr.placeInService.symmetryConditions == symmetryConditionsEnum.ThreePhase
              ? 'durch einen Drehstromgenerator oder einen dreiphasigen Umrichter.'
              : gr.placeInService.symmetryConditions == symmetryConditionsEnum.DeviceBalancing
              ? 'durch eine Symmetrieeinrichtung, die den Unsymmetriewert auf 4,6kVA je Außenleiter begrenzt.'
              : 'durch folgende Aufteilung der einphasig angeschlossenen Erzeugungseinheiten je Außenleiter.'
          "></app-value-with-label>
      </p>

      <div *ngIf="gr.placeInService.symmetryConditions == symmetryConditionsEnum.SinglePhaseDistribution">
        <h4>
          Summe S
          <sub>Emax</sub>
          &nbsp;der neu hinzukommenden Erzeugungsanlagen/Speicher
        </h4>
        <p>
          <app-value-with-label
            *ngIf="gr.placeInService.addedGenerationL1 != null"
            [label]="'L1:'"
            [value]="gr.placeInService.addedGenerationL1.toString() + ' kVA'"></app-value-with-label>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          <app-value-with-label
            *ngIf="gr.placeInService.addedGenerationL2 != null"
            [label]="'L2:'"
            [value]="gr.placeInService.addedGenerationL2.toString() + ' kVA'"></app-value-with-label>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          <app-value-with-label
            *ngIf="gr.placeInService.addedGenerationL3 != null"
            [label]="'L3:'"
            [value]="gr.placeInService.addedGenerationL3.toString() + ' kVA'"></app-value-with-label>
        </p>
        <span
          *ngIf="
            gr.placeInService.existingGenerationL1 != null ||
            gr.placeInService.existingGenerationL2 != null ||
            gr.placeInService.existingGenerationL3 != null
          ">
          <h4>
            Summe S
            <sub>Emax</sub>
            &nbsp;der ggf. vorhandenen Erzeugungsanlagen/Speicher
          </h4>
          <p>
            <app-value-with-label
              *ngIf="gr.placeInService.existingGenerationL1 != null"
              [label]="'L1:'"
              [value]="gr.placeInService.existingGenerationL1 + ' kVA'"></app-value-with-label>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <app-value-with-label
              *ngIf="gr.placeInService.existingGenerationL2 != null"
              [label]="'L2:'"
              [value]="gr.placeInService.existingGenerationL2 + ' kVA'"></app-value-with-label>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <app-value-with-label
              *ngIf="gr.placeInService.existingGenerationL3 != null"
              [label]="'L3:'"
              [value]="gr.placeInService.existingGenerationL3 + ' kVA'"></app-value-with-label>
          </p>
        </span>
      </div>
    </section>

    <section>
      <h3>Datum der EEG-Technischen Inbetriebnahme</h3>
      <p>
        <app-value-with-label
          *ngIf="gr.placeInService.placeInServiceDatum != null"
          [label]="'Datum der Inbetriebnahme:'"
          [value]="gr.placeInService.placeInServiceDatum | date : 'shortDate'"></app-value-with-label>
      </p>
    </section>
  </section>

  <section>
    <h3>Abschluss</h3>
    <p>
      <app-value-with-label
        *ngIf="gr.placeInService.vdeConditions != null"
        [label]="
          'Die Erzeugungsanlage und/oder der Speicher ist/sind nach VDE-AR-N 4105, VDE-AR-N 4100 und den technischen\n' +
          'Anschlussbedingungen des Netzbetreibers errichtet? Der Anlagenerrichter hat den Anlagenbetreiber eingewiesen\n' +
          'und eine vollständige Dokumentation inkl. Schaltplan nach den jeweils gültigen VDE-Bestimmungen übergeben?'
        "
        [value]="gr.placeInService.vdeConditions | jaNeinPipe"></app-value-with-label>
    </p>
  </section>
</div>
